import { render } from "./DialogActionRow.vue?vue&type=template&id=1572d4cc&ts=true"
import script from "./DialogActionRow.vue?vue&type=script&lang=ts"
export * from "./DialogActionRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__